<template>
  <div style="width: 100%;">
    <Tree  :treeNode="treeNode"
          :nodeTrigger="nodeTrigger"
          :checkBox="checkBox"
          :beforeClick="beforeClick"
          :checkBoxType="checkBoxType"
          :clickNode="clickNode"
          :hiddenLine="hiddenLine"
          @checkBoxCall="asyncCheckBoxCall"
          @call='callAsync'
          :async="async"
          :asyncCall="asyncCall"></Tree>
  </div>
</template>
<style lang="less" scoped>
</style>
<script>
import Tree from '_c/common/Tree/Tree.vue'
import SpaceService from '@/assets/service/space'
import { getCookie } from '@/assets/utils/CommonUtil'
import {mapState} from 'vuex'
import r2Project from '@/assets/service/r2Project'
let fileIdsPath = {1: '/'}
let selFilePath = ''
export default {
  components: {
    Tree
  },
  props: {
    pagetype: {
      type: String
    }
  },
  data () {
    return {
      treeNode: [],
      allOpen: null,
      allClose: null,
      nodeTrigger: false,
      /* 是否开启复选框*/
      checkBox: false,
      clickFirstNode: false,
      checkFirstCheckBox: false,
      /* 是否级联选中*/
      checkBoxType: true,
      tree: [],
      trees: [],
      firstIsOpen: false,
      hiddenLine: false,
      async: true,
      userinfo: {},
      fileId: null
    }
  },
  computed: {
    ...mapState({
      // prjStatus: state => state.project.status,
      prjName: state => state.project.name,
      activeTab: state => state.project.activeTab,
      root: state => state.project.root
    })
  },
  methods: {
    isOpen () {
      if (this.allOpen === null) {
        return 'system default 系统默认'
      } else {
        return this.allOpen ? 'open all' : 'close all'
      }
    },
    /* 复选框选中/取消 回调*/
    checkBoxCall (checkBox) {
      console.log('checkBox', checkBox)
    },
    asyncCheckBoxCall (checkBox) {
      console.log('asyncCheckBox', checkBox)
    },
    beforeClick (node) {
      // 可操作内部
      console.log('beforeClick', node)
      if (this.clickFirstNode) { return node.id !== '1' }
      return true
    },
    beforeCheckBox (node) {
      console.log('checkFirstCheckBox', node)
      if (this.checkFirstCheckBox) { return node.id !== '1' }
      return true
    },
    checkBoxHandle (value) {
      console.log('value', value)
    },
    openFirst () {
      this.trees[0].open = !this.trees[0].open
      this.firstIsOpen = this.trees[0].open
    },
    /* 回调初始化后的数据 以后修改tree实现对节点的操作即可*/
    call (data) {
      // console.log('data', data);
      this.trees = data
    },
    callAsync (data) {
      // this.trees = data;
    },
    /* 点击节点信息 上个点击节点信息*/
    clickNode (data, oldData) {
      /* if(data.children){
          data.children.push({
            id: (new Date()).getTime(),
            name:'新增节点',
            children:[]
          });
        }else{
        }*/
      selFilePath = fileIdsPath[data.id]
      // console.log(data, oldData);
      this.$emit('change', selFilePath)
      // data.open=true;
    },
    getWorkspaceId (){
      if (this.pagetype === 'personalList'){
        return getCookie('personalWorkspaceIdValue')
      } else if (this.pagetype === 'projectList'){
        return getCookie('projectWorkspaceIdValue')
      } else if (this.pagetype === 'companyList'){
        return getCookie('enterpriseWorkspaceIdValue')
      }
    },
    /* 异步回调函数 data 当前节点数据 call 回调函数*/
    asyncCall (data, call) {
      if (this.activeTab && +this.activeTab !== 10) {
        let path = fileIdsPath[data.id]
        let parameter = {
          parentPath: path,
          workspaceId: this.getWorkspaceId(),
          parentId: data.fileId
        }
        r2Project.getFolderPrivilegeList(parameter).then((res) => {
          if (+res.code === 200){
            let addNode = []
            res.data.map((item) => {
              addNode.push({
                id: item.fileId,
                name: item.name,
                fileId: item.fileId,
                privilege: item.privilege
              })
              fileIdsPath[item.fileId] = path === '/' ? path + item.name : path + '/' + item.name
            })
            call(addNode)
          }
        })
      } else {
        let path = fileIdsPath[data.id]
        let parameter = {
          path: path,
          workspaceId: this.getWorkspaceId(),
          fileType: 0,
          sortFieldName: 'modifiedTime',
          sortType: 1,
          pageNum: 1,
          pageSize: 100
        }
        SpaceService.getFileListSimple(parameter).then((res) => {
          if (+res.code === 200){
            let addNode = []
            res.data.items.map((item) => {
              if (item.folder){
                addNode.push({
                  id: item.fileId,
                  name: item.name
                })
                fileIdsPath[item.fileId] = path === '/' ? path + item.name : path + '/' + item.name
              }
            })
            call(addNode)
          }
        })
      }
    }
  },
  mounted () {

  },
  created () {
    let name = '我的空间'
    let fileId = ''
    let userinfo = getCookie('ZJYUSERINFO')
    fileIdsPath = {1: '/'}
    selFilePath = ''
    if (userinfo){
      userinfo = JSON.parse(userinfo)
      this.userinfo = userinfo
    }
    switch (this.pagetype){
      case 'companyList':
        name = '企业共享空间'
        break
      case 'personalList':
        if (+this.userinfo.role === 5){
          name = '我的空间'
        } else {
          name = '员工资料库'
        }
        break
      case 'projectList':
        name = '项目库'
        if (this.prjName) {
          if (this.activeTab && +this.activeTab !== 10 && this.activeTab !== '全部文件'){
            fileIdsPath = {1: '/' + this.prjName + '/' + this.activeTab}
            name = this.activeTab
            fileId = this.root[name]
          } else {
            fileIdsPath = {1: '/' + this.prjName}
            name = this.prjName
            fileId = this.$route.params.id
          }
        } else {
          fileIdsPath = {1: '/'}
        }
        break
      default:
    }
    this.treeNode = [
      {
        id: 1,
        name: name,
        fileId: fileId
      }
    ]
  }
}

</script>
